export default "__VITE_ASSET__BiKZQNxL__"